import React from "react";
import { BookOpen, Sparkles, Eye, Zap, Trophy, Heart } from "lucide-react"
import {motion} from "motion/react";
export default function FeaturesPage(){
    
    const features = [
    {
      icon: BookOpen,
      title: 'Reading & Listening',
      items: [
        'Read fanfics and other stories',
        'Listen to audio versions on the go'
      ]
    },
    {
      icon: Sparkles,
      title: 'AI Summaries',
      items: [
        'Get AI-generated summaries',
        'Understand plots quickly'
      ]
    },
    {
      icon: Eye,
      title: 'Modern Design',
      items: [
        'Clean and readable interface',
        'Comfortable for your eyes'
      ]
    },
    {
      icon: Zap,
      title: 'Powerful Infrastructure',
      items: [
        'Built on modern tech stack',
        'Fast and reliable platform'
      ]
    },
    {
      icon: Trophy,
      title: 'Weekly Rating',
      items: [
        'Authors compete for weekly ratings',
        'Earn bonuses and recognition'
      ]
    },
    {
      icon: Heart,
      title: 'Personalized Recommendations',
      items: [
        'Stories tailored for you',
        'Discover content you\'ll love'
      ]
    }
  ];
    
   return (
<div className="w-full bg-gray-50 py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Our Features
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto">
            Everything you need to enjoy stories and fanfics
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl hover:scale-105 transition-all duration-300"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-blue-400 to-purple-500 rounded-xl flex items-center justify-center mb-6 shadow-lg">
                <feature.icon className="w-7 h-7 text-white" />
              </div>
              
              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                {feature.title}
              </h3>
              
              <ul className="space-y-2">
                {feature.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-gray-600">
                    <span className="text-purple-500 mt-1">•</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
   )
}